export const CreateReportDialogService = Symbol('CreateReportDialogService');
